import React from 'react';

import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import noCommentsImage from 'assets/images/action-points-placeholder.png';
import CurvedArrow from 'assets/images/curved-arrow.svg?react';

const ArrowIconContainer = styled.div`
  svg {
    fill: ${(props) => props.theme.palette.borders.lightGrey};
    width: 100%;
    height: auto;
  }
  position: absolute;
  top: -25px;
  right: 50px;
  width: 50px;
  transform: scaleY(-1) rotate(125deg);
  ${(props) => props.theme.breakpoints.down('xs')} {
    display: none;
  }
`;

export default function NoActionPointsView({
  line1 = 'Add action items that team member(s)',
  line2 = 'can track & deliver on',
}) {
  return (
    <Container>
      <div>
        <StyledImage src={noCommentsImage} />
      </div>
      <RightContainer>
        <ArrowIconContainer>
          <CurvedArrow />
        </ArrowIconContainer>
        <StyledTypography bottomGutter={1} variant="body2" weight={600}>
          {line1}
        </StyledTypography>
        <StyledTypography bottomGutter={1} variant="body2" weight={600} color="textSecondary">
          {line2}
        </StyledTypography>
      </RightContainer>
    </Container>
  );
}

const Container = styled.div`
  text-align: center;
  padding: 24px 0;
  display: flex;
  justify-content: space-around;
  ${(props) => props.theme.breakpoints.down('xs')} {
    padding: 24px 24px;
  }
`;

const RightContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  min-width: 60%;
`;

const StyledImage = styled.img`
  max-width: 50%;
`;
